<template>
  <div>
    <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5 pb-10">
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าทนาย</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.lawyerFee"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าหนังสือทวงถาม</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.reminderLetterFee"/>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าธรรมเนียมศาล</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.courtFee"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">ค่าส่งคำคู่ความ</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.summonFee"/>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าจัดทำเอกสาร</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.documentFee"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">ค่าส่งคำบังคับ</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.enforceFee"/>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าดำเนินคดี</label>
          <vs-input type="number" class="input w-1/2" v-model="prosecutionFee.litigationFee"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css'

/**
 * @typedef {Object} ProsecutionFee
 * @property {number} lawyerFee ค่าทนาย
 * @property {number} reminderLetterFee ค่าหนังสือทวงถาม
 * @property {number} courtFee ค่าธรรมเนียมศาล
 * @property {number} summonFee ค่าส่งคำคู่ความ
 * @property {number} documentFee ค่าจัดทำเอกสาร
 * @property {number} enforceFee ค่าส่งคำบังคับ
 * @property {number} litigationFee ค่าดำเนินคดี
 */


export default {
  name: 'LoanInputSection',
  components: {flatPickr},
  props: {
    /** @type {ProsecutionFee} */
    prosecutionFee: {type: Object, required: true}
  },
}
</script>
